import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from "@mui/material";

function SelfPayDependencyDialog({
    open,
    loading,
    contractId,
    dependencies,
    pending,
    actions: { onClose, getSelfPayDependencies }
}) {

if (!open) {
        return null;
     }

    return (
    <Dialog
        open={open}
        maxWidth="sm"
        fullWidth
        onClose={onClose}
    >
        <DialogTitle>
                Self Pay Dependencies
            </DialogTitle>

        <DialogContent dividers>

            {!pending &&
                dependencies.length > 0 && (
                    <>
                        <Typography
                            style={{
                                marginBottom: "16px",
                                fontWeight: 600
                            }}
                        >
                            This contract is linked with the
                            following records:
                        </Typography>

                        {dependencies.map((item, index) => (
                                <div
                                    key={index}
                                    style={{marginBottom: "12px"}}
                                >
                                    <Typography
                                        style={{fontWeight: 600,fontSize:"14px"}}
                                    >
                                        {item.dependentType} ({item.count})
                                    </Typography>

                                    {item.names?.map(
                                        (name,i) => (
                                            <Typography
                                                key={i}
                                                style={{marginLeft:"14px",marginTop: "1px",color:"#4e4d4d"}}
                                            >
                                                • {
                                                    name
                                                }
                                            </Typography>
                                        )
                                    )}
                                </div>
                            )
                        )}
                    </>
                )}
        </DialogContent>

        <DialogActions>
            <Button
                variant="contained"
                onClick={onClose}
            >
                Close
            </Button>
        </DialogActions>
    </Dialog>
);
}

export default SelfPayDependencyDialog;
